// extracted by mini-css-extract-plugin
export default {"containprod":"gA","containprod2":"hA","title":"iA","servings":"jA","recommendation":"kA","image":"lA","flavorswrap":"mA","flavorsgroupwrap":"nA","moredetailsWrap":"oA","infoWrap":"pA","price":"qA","regularPrice":"rA","netPrice":"sA","addtocartcontainer":"tA","error":"uA"};
    if(module.hot) {
      // 1713809678200
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  